export default __webpack_public_path__ + "static/media/ASIA_LOGO.e426ef0a.png";